import { Component } from '@angular/core';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { LOB_DENTAL } from '@cigna/chcp/auth/util';
import { FeatureTogglesFacade } from '@cigna/features';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';
import { SELECTED_USER_TYPE } from '../manage-access.constant';

@Component({
  selector: 'cigna-page-submit-success',
  templateUrl: './page-submit-success.component.html',
  styleUrls: ['./page-submit-success.component.scss'],
})
export class PageSubmitSuccessComponent {
  constructor(
    private manageAccessFacade: ManageUserAccessFacade,
    private authFacade: AuthFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
  ) {}

  selectedUserType$ = this.manageAccessFacade.selectedUserType$;
  selectedUsers$ = this.manageAccessFacade.selectedUsers$;
  hiddenSteps$ = this.manageAccessFacade.hiddenSteps$;
  isVendorSuccess$ = this.manageAccessFacade.isVendorSuccess$;
  steps$ = this.manageAccessFacade.steps$;
  selectedEmailPrintusers$ = this.manageAccessFacade.selectedEmailPrintusers$;
  amLob$ = this.authFacade.lob$;
  EXISTING_USER = SELECTED_USER_TYPE.exisiting;
  NEW_USER = SELECTED_USER_TYPE.new;
  LOB_DENTAL = LOB_DENTAL;

  onUserSelectChange(changeObject: any): void {
    const checked = changeObject.checked;
    const user = changeObject.user;

    if (checked) {
      this.manageAccessFacade.selectUserToPrintEmail(user);
    } else {
      this.manageAccessFacade.unSelectUserToPrintEmail(user);
    }
  }

  onUsersToggleAll(checked: boolean): void {
    this.manageAccessFacade.selectAllUsersToPrintEmail(checked);
  }

  print() {
    // track event for analytics print
    window.print();
  }
}
